const aggregateMetricsByType = (metrics, groupBy, extraCols = []) => {
  if (metrics.length === 0) return [];
  const byKey = {};
  for (let i = 0; i < metrics.length; i++) {
    const metric = metrics[i];
    const groupByValue = metric[groupBy];

    // Handle single value or array of values
    const groupByValues = Array.isArray(groupByValue) ? groupByValue : [groupByValue];

    for (let j = 0; j < groupByValues.length; j++) {
      const currentKey = groupByValues[j];

      // Skip if key is null/undefined
      if (currentKey === null || currentKey === undefined) continue;

      // Initialize bucket if it doesn't exist
      if (!byKey[currentKey]) {
        byKey[currentKey] = {
          [groupBy]: currentKey,
          operationLogsByType: {
            total: 0,
            error: 0,
            warn: 0,
            fail: 0,
            interrupted: 0,
            success: 0
          },

          workflows: []
        };

        // Add extra columns (e.g., companyName, operationsEngineers)
        extraCols.forEach((col) => {
          byKey[currentKey][col] = metric[col];
        });
      }

      const bucket = byKey[currentKey].operationLogsByType;

      // Sum total executions across all workflows
      bucket.total += 1;

      // Count workflows that have at least one of each type
      if (metric.error > 0) bucket.error += 1;
      if (metric.warn > 0) bucket.warn += 1;
      if (metric.fail > 0) bucket.fail += 1;
      if (metric.interrupted > 0) bucket.interrupted += 1;
      if (metric.success > 0 && metric.error === 0 && metric.fail === 0 && metric.interrupted === 0) bucket.success += 1;

      // Add workflow to list
      byKey[currentKey].workflows.push({
        workflowId: metric.workflowId,
        workflowName: metric.workflowName,
        operationLogsByType: {
          total: 1,
          error: metric.error,
          warn: metric.warn,
          fail: metric.fail,
          interrupted: metric.interrupted,
          success: metric.success
        }
      });
    }
  }

  return Object.values(byKey);
};

export { aggregateMetricsByType };
